/*
 * Created Date: 08-10-2021, 1:32:55 pm
 * Author: Trần Quang Hùng
 * Email: you@you.you
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2021 VNE E-COMMERCE, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { studioColor } from '@App/Studio/app-config/theme'
import { useBreakpoints } from '@Core/hooks/useBreakpoints'
import { FormHelperText, InputLabel, TextField } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import clsx from 'clsx'
import { format, formatISO, isValid } from 'date-fns'

import PropTypes from 'prop-types'
import React from 'react'
import { Controller } from 'react-hook-form'
import { useStyles } from './CoreInput'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import vi from 'date-fns/locale/vi'
const CoreDatepicker = props => {
	const {
		className,
		control,
		name,
		options,
		label,
		placeholder,
		InputLabelProps,
		inputProps,
		InputProps,
		shrink,
		required,
		readOnly,
		maxDate,
		helperText,
		size,
		isFormatISO,
		disablePast = false,
		disableFuture = false,
		isMonthChange = false,
		...restProps
	} = props

	const customStyle = useStyles()
	const { mobile } = useBreakpoints()
	const responsiveSize = () => {
		if (String(size)?.trim()?.length > 0) {
			return size
		}
		return mobile ? 'small' : undefined
	}

	return (
		<div className={className}>
			{label ? (
				<InputLabel
					className="text-[1rem] md:text-12 font-medium text-label"
					required={required}
					shrink
					htmlFor={name}
				>
					{label}
				</InputLabel>
			) : null}
			<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={vi}>
				<Controller
					control={control}
					name={name}
					render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => {
						return (
							<DatePicker
								size={responsiveSize()}
								label={null}
								onMonthChange={value => {
									if (isMonthChange) {
										onChange(value)
									}
								}}
								onChange={date => {
									if (isMonthChange) {
										return false
									}
									let invalidDate = false

									if (isValid(date)) {
										const inputedYear = +format(date, 'yyyy')
										if (inputedYear < 1900) {
											invalidDate = true
										}
										if (isFormatISO) {
											date = formatISO(date)
										}
									}
									// console.log('============= date', date)
									onChange(invalidDate ? 'Invalid Date' : date)
								}}
								value={value}
								disablePast={disablePast}
								disableFuture={disableFuture}
								inputRef={ref}
								// mask="____/__/__"
								inputFormat="dd/MM/yyyy"
								// readOnly={readOnly}
								maxDate={maxDate}
								className={clsx('w-full', customStyle.root)}
								sx={{
									svg: { color: studioColor.main_violet }
									// input: { color },
									// label: { color }
								}}
								slotProps={{
									textField: {
										helperText: error && error.message,
										error: Boolean(error?.message),
										size
									},
									field: { clearable: true }
								}}
								{...restProps}
							/>
						)
					}}
				/>
			</LocalizationProvider>
		</div>
	)
}

CoreDatepicker.defaultProps = {
	className: null,
	label: null,
	placeholder: null,
	InputLabelProps: null,
	inputProps: null,
	InputProps: null,
	shrink: true,
	required: false,
	readOnly: false,
	maxDate: null,
	isFormatISO: false
}

CoreDatepicker.propTypes = {
	className: PropTypes.string,
	control: PropTypes.object.isRequired,
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	placeholder: PropTypes.string,
	InputLabelProps: PropTypes.object,
	inputProps: PropTypes.object,
	InputProps: PropTypes.object,
	shrink: PropTypes.bool,
	required: PropTypes.bool,
	readOnly: PropTypes.bool,
	maxDate: PropTypes.any,
	minDate: PropTypes.any,
	disabled: PropTypes.bool,
	disablePast: PropTypes.bool,
	disableFuture: PropTypes.bool,
	helperText: PropTypes.any,
	isFormatISO: PropTypes.bool
}

export default React.memo(CoreDatepicker)
